// 封装一些用的API，不用把URL写在页面中，直接调用即可
import http from './request.js'

// 设置个对象，就不用一个个暴露了，直接暴露对象
// 在页面引用的时候就可以用apiFun.方法的方式
const apiFun = {}
/**
 *
 * @param {*} params
 * @returns
 */
apiFun.login = function(params) {

    return http.post('/sqmv1/aa/a1', params)
}

apiFun.staff_login = function(params) {
    return http.post('/sqmv1/aa/a6', params)
}

//添加菜单
apiFun.addmenu = function(params) {

    return http.post('/sqmv1/ff/f2', params)
}
//菜单列表
apiFun.listmenu = function(params) {

    return http.post('/sqmv1/ff/f1', params)
}
//获取菜单列表数据
apiFun.getlistmenu = function(params) {
    return http.get('/sqmv1/ff/f10', params)
}


//获取音色列表数据
//2025916添加
apiFun.getRecordingList = function(params) {
  return http.post('/sqmv1/jj/j46', params)
}
//2025916添加
//合成录音
apiFun.addRecording = function(params) {

  return http.post('/sqmv1/jj/j68', params)
}


//删除菜单
apiFun.delmenu = function(params) {

    return http.get('/sqmv1/ff/f5', params)
}

apiFun.getverifycode = function(params) {
    return http.get('/sqmv1/aa/a2', params)
}
apiFun.getsigaltaskphonelist = function(params){
    return http.get('/sqmv1/')
}
apiFun.getusertypelist = function(){
    return http.get('/sqmv1/cc/c1')
}
apiFun.getprovincelist = function(params) {
    return http.get('/sqmv1/apiv1/av1', params)
}
apiFun.getcitylist = function(params) {
    return http.get('/sqmv1/apiv1/av2', params)
}
apiFun.getuserlist = function(params) {
    return http.get('/sqmv1/bb/b1', params)
}
apiFun.adduser = function(data) {
    return http.post('/sqmv1/bb/b2', data)
}
apiFun.edituser = function(data) {
    return http.post('/sqmv1/bb/b4', data)
}
apiFun.deluser = function(data) {
    return http.get('/sqmv1/bb/b5', data)
}
apiFun.changeuserstatus = function(params) {
    return http.get('/sqmv1/bb/b6', params)
}
apiFun.chargeuser = function(data) {
    return http.post('/sqmv1/bb/b10', data)
}
apiFun.getlinelist = function(params) {
    return http.get('/sqmv1/dd/d2', params)
}
apiFun.getlineinfo = function(params){
    return http.get('/sqmv1/dd/d8', params)
}
apiFun.addline = function(data) {
    return http.post('/sqmv1/dd/d4', data)
}
apiFun.editline = function(data) {
    return http.post('/sqmv1/dd/d6', data)
}
apiFun.delline = function(params) {
    return http.get('/sqmv1/dd/d10', params)
}
apiFun.getasrlist = function(params){
    return http.get('/sqmv1/ee/e1', params)
}
apiFun.addasr = function(data){
    return http.post('/sqmv1/ee/e2', data)
}
apiFun.editasr = function(data){
    return http.post('/sqmv1/ee/e3', data)
}
apiFun.delasr = function(params){
    return http.get('/sqmv1/ee/e5', params)
}
apiFun.searchlines = function(params){
    return http.get('/sqmv1/apiv1/av3', params)
}
apiFun.searchasrs = function(params){
    return http.get('/sqmv1/apiv1/av4', params)
}
apiFun.chargeloglist = function(params){
    return http.get('/sqmv1/apiv1/av5', params)
}
apiFun.asrtypelist = function(params){
    return http.get('/sqmv1/apiv1/av6', params)
}
apiFun.talkstatustypelist = function(params){
    return http.get('/sqmv1/apiv1/av7', params)
}
apiFun.intensiontypelist = function(params){
    return http.get('/sqmv1/apiv1/av8', params)
}
apiFun.stufflist = function(params){
    return http.get('/sqmv1/ue/ue6', params)
}
apiFun.wechatlist = function(params){
    return http.get('/sqmv1/apiv1/av10', params)
}
apiFun.phonelist = function(params){
    return http.get('/sqmv1/apiv1/av11', params)
}
//任务状态类别
apiFun.taskstatustypelist = function(params){
    return http.get('/sqmv1/apiv1/av12', params)
}
apiFun.talknumberlist = function(params){
    return http.get('/sqmv1/apiv1/av14', params)
}
apiFun.talktimelist = function(params){
    return http.get('/sqmv1/apiv1/av13', params)
}
apiFun.directiontypelist = function(params){
    return http.get('/sqmv1/apiv1/av15', params)
}
apiFun.taskssearchfornamelist = function(params){
    return http.get('/sqmv1/apiv1/av16', params)
}
//角色列表
apiFun.roleslist = function(params){
    return http.post('/sqmv1/cc/c1', params)
}
//添加角色
apiFun.addroles = function(params){
    return http.post('/sqmv1/cc/c2', params)
}
//删除角色
apiFun.delRoles = function(params){
    return http.get('/sqmv1/cc/c5', params)
}
//公司列表
apiFun.systemsettingist = function(params){
    return http.post('/sqmv1/hh/h1', params)
}

//添加 & 编辑
apiFun.addcompany = function(params){
    return http.post('/sqmv1/hh/h2', params)
}

//删除公司
apiFun.delcompany = function(params){
    return http.get('/sqmv1/hh/h4', params)
}

//上传文件
apiFun.uploadFile = function(params){
    return http.uploads('/sqmv1/hh/h3', params)
}

//公众号列表
apiFun.wechataccountlist = function(params){
    return http.post('/sqmv1/ii/i1', params)
}

//公众号添加 & 编辑
apiFun.addwechataccount = function(params){
    return http.post('/sqmv1/ii/i2', params)
}

//删除公众号
apiFun.delwechataccount = function(params){
    return http.get('/sqmv1/ii/i4', params)
}


//操作记录列表
apiFun.operatelist = function(params){
    return http.post('/sqmv1/ii/i5', params)
}

//操作记录详情
apiFun.operatedetails = function(params){
    return http.post('/sqmv1/ii/i6', params)
}
//群呼系统 通话记录
apiFun.getCallHisList = function(params){
    return http.post('/sqmv1/apiv1/av22', params)
}
// 通话记录 全选
apiFun.getAllCallHisList = function(params){
    return http.post('/sqmv1/apiv1/av58', params)
}
//AI 通话记录详情
apiFun.getCallHisInfo = function(params){
    return http.post('/sqmv1/jj/j33', params)
}
//wecta通话记录详情
apiFun.getweixinCallHisInfo = function(params){
    return http.get('/sqmv1/jj/j57', params)
}
//群呼系统 通话记录详情
apiFun.getCallManageHisInfo = function(params){
    return http.get('/sqmv1/apiv1/av28', params)
}

apiFun.getCallHisInfoRemark = function(params){
    return http.post('/sqmv1/jj/j38', params)
}
apiFun.getCallQunHisList = function(params){
    return http.get('/sqmv1/apiv1/av29', params)
}
apiFun.getEditLikeRule = function(params){
    return http.post('/sqmv1/jj/j34', params)
}



//crm客户管理相关
apiFun.getCustomerList = function(params){
    return http.get('/sqmv1/crm/getCustomerList', params)
}
apiFun.addCustomer = function(params){
    return http.post('/sqmv1/crm/addCustomer', params)
}
apiFun.editCustomer = function(params){
    return http.post('/sqmv1/crm/editCustomer', params)
}
apiFun.getCustomerDetail = function(params){
    return http.get('/sqmv1/crm/getCustomerDetail', params)
}
apiFun.editCustomerDetail = function(params){
    return http.post('/sqmv1/crm/editCustomerDetail', params)
}
apiFun.batchChangeOwnership = function(params){
    return http.post('/sqmv1/crm/batchChangeOwnership', params)
}
apiFun.addFollowRecord = function(params){
    return http.post('/sqmv1/crm/addFollowRecord', params)
}
apiFun.fallOpenSea = function(params){
    return http.post('/sqmv1/crm/fallOpenSea', params)
}
apiFun.getFollowRecord = function(params){
    return http.get('/sqmv1/crm/getFollowRecord', params)
}
apiFun.editFollowRecord = function(params){
    return http.post('/sqmv1/crm/editFollowRecord', params)
}
apiFun.batchDelete = function(params){
    return http.post('/sqmv1/crm/batchDelete', params)
}
apiFun.batchAllocation = function(params){
    return http.post('/sqmv1/crm/batchAllocation', params)
}
apiFun.batchAllocation = function(params){
    return http.post('/sqmv1/crm/batchAllocation', params)
}
apiFun.importCustomer = function(params){
    return http.post('/sqmv1/crm/import', params)
}
apiFun.exportCustomer = function(params){
    return http.get('/sqmv1/crm/export', params)
}
apiFun.getConversationInfo = function(params){
    return http.get('/sqmv1/crm/getConversationInfo', params)
}

apiFun.getDealRecord = function(params){
    return http.get('/sqmv1/crm/getDealRecord', params)
}
apiFun.getCallRecord = function(params){
    return http.get('/sqmv1/crm/getCallRecord', params)
}
//公海
apiFun.getOpenSeaList = function(params){
    return http.get('/sqmv1/crm/getOpenSeaList', params)
}
apiFun.receive = function(params){
    return http.post('/sqmv1/crm/receive', params)
}
apiFun.openSeaExport = function(params){
    return http.get('/sqmv1/crm/openSeaExport', params)
}
apiFun.moveWechatToOpenSea = function(params) {
    return http.post('/sqmv1/crm/wechatCustomerMoveToOpenSea', params)
}
//crm设置
apiFun.getOpenSeaSetting = function(params){
    return http.get('/sqmv1/crm/getOpenSeaSetting', params)
}
apiFun.setOpenSeaSetting = function(params){
    return http.post('/sqmv1/crm/setOpenSeaSetting', params)
}
apiFun.getWechatList = function(params){
    return http.get('/sqmv1/crm/getWechatList', params)
}
apiFun.addWechat = function(params){
    return http.post('/sqmv1/crm/addWechat', params)
}
apiFun.editWechat = function(params){
    return http.post('/sqmv1/crm/editWechat', params)
}
apiFun.delWechat = function(params){
    return http.post('/sqmv1/crm/delWechat', params)
}
apiFun.wechatTransfer = function(params){
    return http.post('/sqmv1/crm/wechatTransfer', params)
}
apiFun.getWechatTransferList = function(params){
    return http.get('/sqmv1/crm/getWechatTransferList', params)
}

//组织架构
apiFun.getStaffList = function(params){
    return http.get('/sqmv1/org/getStaffList', params)
}
apiFun.getAllStaffList = function(params){
return http.get('/sqmv1/org/getAllStaffList', params);
}
apiFun.addStaff = function(params){
    return http.post('/sqmv1/org/addStaff', params)
}
apiFun.editStaff = function(params){
    return http.post('/sqmv1/org/editStaff', params)
}
apiFun.delStaff = function(params){
    return http.post('/sqmv1/org/delStaff', params)
}
apiFun.updatePassword = function(params){
    return http.post('/sqmv1/org/updatePassword', params)
}

apiFun.getDepartmentList = function(params){
    return http.get('/sqmv1/org/getDepartmentList', params)
}
apiFun.getDepartmentAllList = function(params){
    return http.get('/sqmv1/org/getAllDepartmentList', params)
}
apiFun.addDepartment = function(params){
    return http.post('/sqmv1/org/addDepartment', params)
}
apiFun.editDepartment = function(params){
    return http.post('/sqmv1/org/editDepartment', params)
}
apiFun.delDepartment = function(params){
    return http.post('/sqmv1/org/delDepartment', params)
}

apiFun.getMenuList = function(params){
    return http.get('/sqmv1/org/getMenuList', params)
}
apiFun.getRoleList = function(params){
    return http.get('/sqmv1/org/getRoleList', params)
}
apiFun.getRankList = function(params){
    return http.get('/sqmv1/org/getRankList', params)
}
apiFun.addRank = function(params){
    return http.post('/sqmv1/org/addRank', params)
}
apiFun.addRole = function(params){
    return http.post('/sqmv1/org/addRole', params)
}
apiFun.delRank = function(params){
    return http.post('/sqmv1/org/delRank', params)
}
apiFun.delRole = function(params){
    return http.post('/sqmv1/org/delRole', params)
}

apiFun.saveRole = function(params){
    return http.post('/sqmv1/org/saveRole', params)
}

//微信管理
apiFun.getWechatCustomerList = function(params){
    return http.get('/sqmv1/crm/getWechatCustomerList', params)
}
apiFun.addWechatCustomer = function(params){
    return http.post('/sqmv1/crm/addWechatCustomer', params)
}
apiFun.editWechatCustomer = function(params){
    return http.post('/sqmv1/crm/editWechatCustomer', params)
}
apiFun.delWechatCustomer = function(params){
    return http.post('/sqmv1/crm/delWechatCustomer', params)
}
apiFun.wechatCustomerImport = function(params){
    return http.post('/sqmv1/crm/wechatCustomerImport', params)
}
apiFun.wechatCustomerExport = function(params){
    return http.get('/sqmv1/crm/wechatCustomerExport', params)
}
apiFun.uploadFiles = function(params){
    return http.uploads('/sqmv1/crm/uploadFile', params)
}
apiFun.uploadImage = function(params){
    return http.uploads('/sqmv1/hh/h3', params)
}

//数据中心
apiFun.getCustomerStat = function(params){
    return http.get('/sqmv1/crm/getCustomerStat', params)
}
apiFun.getCustomerData = function(params){
    return http.get('/sqmv1/crm/getCustomerData', params)
}
apiFun.getSellStat = function(params){
    return http.get('/sqmv1/crm/getSellStat', params)
}
apiFun.getMessageList = function(params){
    return http.get('/sqmv1/crm/getMessageList', params)
}
apiFun.getMemoList = function(params){
    return http.get('/sqmv1/crm/getMemoList', params)
}
apiFun.addMemo = function(params){
    return http.post('/sqmv1/crm/addMemo', params)
}
apiFun.finishMemo = function(params){
    return http.post('/sqmv1/crm/finishMemo', params)
}
apiFun.getStaffRanking = function(params){
    return http.get('/sqmv1/crm/getStaffRanking', params)
}
apiFun.getDepartmentRanking = function(params){
    return http.get('/sqmv1/crm/getDepartmentRanking', params)
}
apiFun.todayNotFollow = function(params){
    return http.get('/sqmv1/crm/todayNotFollow', params)
}
//大数据
apiFun.getDsjToken = function(params){
    return http.get('/sqmv1/dsj/getDsjToken', params)
}
apiFun.getAccountList = function(params){
    return http.get('/sqmv1/dsj/getAccountList', params)
}
apiFun.updateAccount = function(params){
    return http.post('/sqmv1/dsj/updateAccount', params)
}
apiFun.restMeal = function(params){
    return http.post('/sqmv1/dsj/restMeal', params)
}
apiFun.modifyAccount = function(params){
    return http.post('/sqmv1/dsj/modifyAccount', params)
}
apiFun.cleanAccountLoginStatus = function(params){
  return http.post('/sqmv1/dsj/cleanDsjToken', params)
}
apiFun.getThread = function(params){
  return http.post('/sqmv1/dsj/ds1', params)
}
apiFun.addOutbound = function(params){
  return http.post('/sqmv1/dsj/ds2', params)
}
//登录二维码
apiFun.getQord = function(params){
    return http.get('/sqmv1/aa/a3',params)
}
apiFun.getuserListType = function(){
    return http.get('/sqmv1/apiv1/av57')
}
//获取天气等信息
apiFun.getWeatherString = function(){
    return http.post('/sqmv1/aa/a100')
}

// 公告列表
apiFun.noticeList = function(params){
    return http.get('/sqmv1/xtxx/x1',params)
}
// 公告列表 历史记录
apiFun.noticeUserList = function(params){
    return http.get('/sqmv1/xtxx/x5',params)
}
// 添加公告
apiFun.noticeAdd = function(params){
    return http.post('/sqmv1/xtxx/x2',params)
}
// 修改公告
apiFun.noticeEdit = function(params){
    return http.post('/sqmv1/xtxx/x3',params)
}
// 删除公告
apiFun.noticeDelete = function(params){
    return http.get('/sqmv1/xtxx/x4',params)
}
// 登录弹出公告内容
apiFun.noticeData = function(){
    return http.get('/sqmv1/xtxx/x6')
}
// 已读消息标记
apiFun.noticeRead = function(params){
    return http.get('/sqmv1/xtxx/x7',params)
}
// 一键暂停、恢复所有任务
apiFun.updateTask = function(status){
    return http.get('/sqmv1/kk/k37?status=' + status)
}
// 白名单列表 - 查询
apiFun.whiteList = function(params){
    return http.get('/sqmv1/hh/h5',params)
}
// 白名单列表 - 添加
apiFun.whiteAdd = function(params){
    return http.post('/sqmv1/hh/h7',params)
}
// 白名单列表 - 删除
apiFun.whiteDel = function(params){
    return http.post('/sqmv1/hh/h8',params)
}
// 查询账号是否支持挖掘
apiFun.ds4 = function(){
    return http.post('/sqmv1/dsj/ds4')
}
// 下载号码
apiFun.ds6 = function(data){
    return http.post('/sqmv1/dsj/ds6',data)
}
// 暴露出这个对象
export default apiFun


